
import { Fragment, useEffect, useState } from "react";
import { t } from "i18next";

import { BrandedWhitSupporetdText } from "../atoms/BrandedWithSupportedText";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import ColumnText from "../molecules/ColumnText";
import { Empty } from "./Empty";

type BondUser = {
  id: number;
  name: string;
  bond_id: number;
  state: number;
  payment: any;
  status: string;
  bondId: number;
  sessionMissing: number;
  groupbond_id: number;
  groupbond: {
    name: string;
  };
};

type BonosProps = {
  id: number | string;
  group: string;
  name: string;
  descripcion: string;
  price: number;
  sessions: string;
  daysCaducity: string;
  state: string;
  sessionsAvailable: string;
  session: string;
  currency: string;
  payment: string;
  groupbond_id: number;
  groupbond: {
    name: string;
  };
  days: string;
  status: number;
  repeated_bonus: string;
};

type option = {
  id: string | number;
  title: string;
  description: string;
  function: () => void;
};
export type TableListBonosSPProps = {
  bonos: BonosProps[];
  assignedBonds: BonosProps[];
  titleBranded: string;
  titleBrandedActiveFee: string;
  OptionsBrandedActiveFee: option[];
  OnAssingBond: () => void;
  updateBondUserButton: (bod: BondUser, val: string) => void;
  user: any;
  loggedUser: any;
};

export const TableListBonosSP: React.FC<TableListBonosSPProps> = ({
  bonos,
  assignedBonds,
  titleBranded,
  titleBrandedActiveFee,
  OptionsBrandedActiveFee,
  OnAssingBond,
  updateBondUserButton,
  user,
  loggedUser,
}) => {
  const [filteredBonos, setFilteredBonos] = useState(bonos);

  const onSearch = (value: string) => {
    const filtered = bonos.filter((curso) =>
      curso.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredBonos(filtered);
  };

  useEffect(() => {
    if (user) {
      //console.log(user, filteredBonos, assignedBonds);
    }
  }, [user])

  const hasActiveBond = (user, bondId) => {
    return user.bonds_user?.some(
      (bondUser) => bondUser.bond_id === bondId && bondUser.state === true
    );
  };
  
  const getActiveBond = (user, bondId) => {
    return user.bonds_user?.find(
      (bondUser) => bondUser.bond_id === bondId && bondUser.state === true
    );
  };
  
  const hasFailedPayment = (user, bondId) => {
    return user.bonds_user?.some(
      (bondUser) =>
        bondUser.bond_id === bondId &&
        bondUser.status === "fail" &&
        bondUser.payment === 0 &&
        bondUser.state === true
    );
  };

  return (
    <div className="mt-5 overflow-visible">
      <div className="px-2 sm:px-3 lg:px-6">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4">
          <div></div>
          <div className="mt-2 sm:mt-0">
            <InputWithCornerHint
              type="text"
              label=""
              placeholder={t("store.views.form.search_by_name")}
              onChange={(e) => onSearch(e.target.value)}
            />
          </div>
        </div>
        {/* Divider debajo del texto */}
        <div className="flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto relative sm:-mx-6 lg:-mx-8 px-4">
            <div className="inline-block min-w-full px-3 py-2 align-middle">
              {bonos.length === 0 ? (
                <Empty texto={t("customer-to-gym-subscription.views.no_fee")} />
              ) : (
                <Fragment>
                  <table className="min-w-full divide-y divide-gray-300 border-t border-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-1/12"
                        >
                          {t("bond.views.group")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-2/12"
                        >
                          {t("customer-to-gym-subscription.views.name")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-2/12"
                        >
                          {t("customer-to-gym-subscription.views.description")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("customer-to-gym-subscription.views.price")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("bond.views.sessions")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("bond.views.days_title")}
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >
                          {t("bond.views.status")}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {filteredBonos.map((bono) => {

                        const options = [];

                        // Validación para asignar bono
                        if (
                          (bono.repeated_bonus && user.role !== "Coach") ||
                          user.bonds_user.find(
                            (bondUser: BondUser) =>
                              bondUser.bondId === bono.id && bondUser.state
                          )?.sessionMissing <= 0
                        ) {
                          options.push({
                            title: "Asignar",
                            description: "Asignar bono",
                            onClick: OnAssingBond,
                            primary: true,
                            current: false,
                          });

                          options.push({
                            title: "Modificar",
                            description: "Modificar bono",
                            onClick: () =>
                              OptionsBrandedActiveFee[1].function(),
                            primary: false,
                            current: false,
                          });
                        }

                        // Validación para transferir bono
                        if (
                          user.bonds_user.find(
                            (bondUser: BondUser) =>
                              bondUser.bondId === bono.id && bondUser.state
                          )?.sessionMissing > 0
                        ) {
                          options.push({
                            title: t("share.views.transfer"),
                            description: 'Transferir bono',
                            onClick: () =>
                              OptionsBrandedActiveFee[2].function(),
                            primary: false,
                            current: false,
                          });

                          options.push({
                            title: "Modificar",
                            description: "Modificar bono",
                            onClick: () =>
                                OptionsBrandedActiveFee[1].function(),
                            primary: false,
                            current: false,
                          });
                        }

                        /*
                          updateBondUserButton(
                            user.bonds_user.find(
                              (bondUser: BondUser) =>
                                bondUser.bondId === bono.id && bondUser.state
                            ).id,
                            "assisted"
                          ),
                          */

                        // Validación para mostrar el botón de pago pendiente
                        if (
                          user.bonds_user.find(
                            (bondUser: BondUser) =>
                              bondUser.bondId === bono.id &&
                              bondUser.payment === 0 &&
                              bondUser.status === "fail" &&
                              bondUser.state
                          )
                        ) {
                          options.push({
                            title: t("fees.views.button_pay"),
                            description: t("fees.views.pay_pending_description"),
                            onClick: () => console.log("Pay bond:", bono.id),
                            primary: true,
                            current: false,
                          });
                        }

                        return (
                          <tr key={bono.id}>
                            <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-1/12">
                              {bono.groupbond.name}
                            </td>
                            <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-2/12">
                              {bono.name}
                            </td>
                            <td className="px-3 py-3.5 text-left text-sm text-gray-500 w-2/12">
                              {bono.descripcion}
                            </td>
                            <ColumnText
                              title={`${bono.price} ${bono.currency}`}
                            />
                            <ColumnText title={bono.session} />
                            <ColumnText title={bono.days} />

                            <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                              <span
                                className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${
                                  bono.status === 1
                                    ? "bg-green-50 text-green-700 ring-green-600/20"
                                    : bono.status === 0
                                      ? "bg-red-50 text-red-700 ring-red-600/20"
                                      : "bg-gray-50 text-gray-700 ring-gray-600/20"
                                } ring-1 ring-inset `}
                              >
                                {bono.status === 1
                                  ? t("stripe.views.active")
                                  : bono.status === 0
                                    ? t("stripe.views.inactive")
                                    : t("fees.views.low")}
                              </span>

                              {hasActiveBond(user, bono.id) && (
                                <>
                                  {/* Mostrar la fecha de finalización si está disponible */}
                                  {getActiveBond(user, bono.id)?.date_finish && (
                                    <span style={{ fontSize: "10px" }}>
                                      {t("fees.views.state_payment_paid")} :{" "}
                                      {new Date(
                                        getActiveBond(user, bono.id).date_finish
                                      ).toLocaleDateString("en-GB")}
                                    </span>
                                  )}
                                </>
                              )}

                              {/* Verificar si hay un pago rechazado */}
                              {hasFailedPayment(user, bono.id) && (
                                <span style={{ fontSize: "10px" }} className="text-danger">
                                  {t("fees.views.rejected_payment")}
                                </span>
                              )}
                            </td>

                            <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-sm font-medium sm:pr-0">
                              <div className="flex flex-col items-center justify-center">
                                {bono.status === 1 &&
                                  !user.bondPaymentPending ? (
                                    assignedBonds.filter(
                                      (assigned) =>
                                        assigned.groupbond_id === bono.groupbond_id
                                    ).length === 0 ? (
                                      loggedUser.role !== "Coach" && (
                                        <button
                                          onClick={OnAssingBond}
                                          className="text-white text-sm font-semibold inline-flex items-center rounded-l-md rounded-r-md bg-primary-600 p-2 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 focus:ring-offset-gray-50"
                                        >
                                          {t("bond.views.assign")}
                                        </button>
                                      )
                                    ) : user.bonds_user.filter(
                                        (bondUser: BondUser) =>
                                          bondUser.bondId === bono.id &&
                                          bondUser.state
                                        ).length > 0 ? (
                                          <>
                                            {t("fees.views.sesion_available")}
                                            {
                                              user.bonds_user.find(
                                                (bondUser: BondUser) =>
                                                  bondUser.bondId === bono.id &&
                                                  bondUser.state
                                              ).session_missing
                                            }{" / "}
                                            {bono.session}

                                            <br />

                                            <BrandedWhitSupporetdText
                                              title={t("fees.views.button_action")}
                                              options={options}
                                            />
                                          </>
                                        ) : (
                                          <>
                                            <p className="bond-already-assigned">
                                              {t("bond.views.already_assigned")}
                                            </p>
                                          </>
                                        )
                                  ) : null
                                }
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
